import script from "./WidgetActiveTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetActiveTickets.vue?vue&type=script&setup=true&lang=js"

import "./WidgetActiveTickets.vue?vue&type=style&index=0&id=598a8e7c&lang=css"

const __exports__ = script;

export default __exports__